"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18.2",
    width: "24",
    height: "18.2"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M5,18.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S6.4,18.2,5,18.2z M5,14.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S5.8,14.2,5,14.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M19,18.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S20.4,18.2,19,18.2z M19,14.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S19.8,14.2,19,14.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M17,16.2H7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10c0.3,0,0.5,0.2,0.5,0.5S17.3,16.2,17,16.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M4.5,9.2c-0.1,0-0.2,0-0.2-0.1C4,9,3.9,8.7,4.1,8.5l1.5-3C5.6,5.3,5.8,5.2,6,5.2h1.5C7.8,5.2,8,5.4,8,5.7 S7.8,6.2,7.5,6.2H6.3L4.9,8.9C4.9,9.1,4.7,9.2,4.5,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3,16.2H0.5C0.2,16.2,0,16,0,15.7v-5.5c0-0.1,0.1-0.3,0.1-0.4l2-2l2.5-4.4C4.7,3.3,4.8,3.2,5,3.2h4.5 c0.3,0,0.5,0.2,0.5,0.5v10c0,0.3-0.2,0.5-0.5,0.5S9,14,9,13.7V4.2H5.3L2.9,8.4c0,0-0.1,0.1-0.1,0.1L1,10.4v4.8h2 c0.3,0,0.5,0.2,0.5,0.5S3.3,16.2,3,16.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M23.5,16.2H21c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2v-1H0.5C0.2,14.2,0,14,0,13.7s0.2-0.5,0.5-0.5h23 c0.3,0,0.5,0.2,0.5,0.5v2C24,16,23.8,16.2,23.5,16.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M23.5,14.2h-14C9.2,14.2,9,14,9,13.7v-3c0-0.3,0.2-0.5,0.5-0.5h14c0.3,0,0.5,0.2,0.5,0.5v3 C24,14,23.8,14.2,23.5,14.2z M10,13.2h13v-2H10V13.2z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "17.2",
    cy: "4.3",
    r: "4.3"
  }));
};

exports["default"] = _default;